import { pp, notify, e, downloadFile } from '@helpers'

import { setCssVar } from 'quasar'


export const useAppStore = {

    state: ()/* : State */ => ({

        MaintenanceON: false, // si une maintenance mensuelle est convenue...

        appversion: '0.0.5', // FOR VERSIONING /!\ same in public/js/vuejs/appversion.json (created by components/partials/Versioning.vue)
        /**
         * For count tabs opened with app connected
         * For message in Components/partials/UpgradeAppVersionUser.vue
         * Used too in Layouts/Auth.vue  too
         */
        tabsOpenKey: 'tabsOpened_tms_app',

        ready: false, // used in App.vue (datas loaded, ready for show page)
        show_page: false, // used in Layouts

        app_name: 'TMS',

        // current_route: '',

        upload_video_is_running: false,

        all_users: [],

        contact_form_message: null, // save a message if close modal ContactMail

        no_reopen_alerts: {}, // ne pas rouvrir certaines alertes (en mettant sur MyAlert l'attribut no-reopen-alert-id="alert_xxxxx")

        open_direct_msg_text: true,
        open_direct_msg_form: false,
        direct_msg_model_session: false,
        direct_msg_form_for_reply: false,

        // header: true,
        headerReveal: true,

        // for ASIDES
        openDrawerLeft: true,
        // left: true,
        // leftOverlay: false,
        // leftBehavior: 'mobile', // default|mobile|desktop
        // leftBreakpoint: 992,

        openDrawerRight: false,
        // right: false,
        // rightOverlay: true,
        // rightBehavior: 'mobile', // default|mobile|desktop
        // rightBreakpoint: 992,


        openDrawerActions: false,

        counter: null,
        count_minutes_without_inactivity: 0,
        modalAutoDisconnect: null,


        scrollarea_bar_style_left: {left: '2px',width: '5px',height: '5px',borderRadius: '5px',backgroundColor: '#AAAAAA', opacity: 0.5},
        scrollarea_bar_style_right: {right: '2px',width: '5px',height: '5px',borderRadius: '5px',backgroundColor: '#AAAAAA', opacity: 0.5},


        messageOfWebmaster: null,

        reloadMasonry: false,

        current_page_for_guided_tour: null,

        squared: false, // coins Arrondis ou Carrés

    }),

    // getters: {

    //     getXxxx(){
    //         return (var) => {
    //             return
    //         }
    //     },
    // },

    actions: {

        // async setDatas(){

        //     // await this.getAllUsers()
        //     // log('in setDatas()')

        //     await this.customizer()

        //     // _.delay(()=>{
        //         this.ready = true
        //     // }, 1000)
        // },

        /**
         * @param Boolean force (true after edit/create user)
         */
        async getAllUsers(force = false){

            if((pp()?.user && ! _.size(this.all_users)) || force){

                // state.all_users = ['waiting']

                await axios.get(route('get-all-users'))
                    .then((res) => {
                        // this.all_users = res.data.all_users
                        this.all_users = res.data
                    })
                    // .catch((error) => {
                    //     e('app/actions.js - getAllUsers', error)
                    // });

                // proto.$inertia.post(route('get-all-users'),{
                //     onSuccess:(res)=>{
                //         log(res)
                //         this.all_users = res
                //     }
                // })
            }

            this.ready = true

            // log('in getAllUsers()', force, this.all_users)
        },


        customizer(){
            let ppf = pp()

            // var colors = pp().utils?.custom.colors
            var custom = ppf?.utils?.custom
            var colors = ! ppf?.user?.custom?.colors ? custom.colors/*default colors*/ : ppf?.user.custom.colors/*colors of user*/


        // log('in customizer()', colors)

            setCssVar('dark-page',  '#232323') // background
            setCssVar('dark',       '#323232') // elements
            setCssVar('primary',    colors?.primary || '#455A64')//'#455A64') // blue-grey-8
            setCssVar('secondary',  colors?.secondary || '#607D8B')//'#607D8B') // blue-grey-6
            setCssVar('info',      '#29B6F6')// light-blue-5
            setCssVar('warning',   '#FB8C00')// orange-7


            if( ! $q.cookies.has('dark_mode')){
                $q.dark.set(Boolean(custom?.mode_dark)) // mode_dark par défaut, depuis les paramètres de l'appli
            }
        },

        // SAUVEGARDE BDD
        async dumpDB() {

            $q.loading.show({message: "Sauvegarde en cours..."})

            // await axios.get('/fonctionnalities/dump-db', {
            await axios.get(route('dump-db'), {
                    responseType: 'blob'
                })
                .then((response) => {
                    if (response.data.error) {
                        notify("negative", response.data.error);
                    } else {
                        downloadFile(response); // helper link_helpers
                    }
                })
                .catch((error) => {
                    e("app/actions - dumpDB", error);
                });

                $q.loading.hide()
        },

    },
}
